import { render, staticRenderFns } from "./index.vue?vue&type=template&id=efd8a874&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/live-watch/_live-watch.scss?vue&type=style&index=0&id=efd8a874&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd8a874",
  null
  
)

export default component.exports